// Angular
import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

// Models
import { AppCleanup } from '../../models';

// Helpers
import { FormHelper } from '../../helpers';

@Component({
  selector: 'value-dialog',
  templateUrl: './value-dialog.component.html',
  styleUrls: ['./value-dialog.component.scss'],
})
export class ValueDialogComponent extends AppCleanup implements OnInit, OnDestroy {
  title: string = 'Set value';
  action: string = 'Save';
  label: string = 'Value';
  existingValue: number;
  form: FormGroup;

  constructor(
    private formBuilder: FormBuilder,
    private dialogRef: MatDialogRef<ValueDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { title: string; label: string; action: string; existingValue: number }
  ) {
    super();
  }

  ngOnInit() {
    if (this.data?.title) {
      this.title = this.data.title;
    }

    if (this.data?.action) {
      this.action = this.data.action;
    }

    if (this.data?.label) {
      this.label = this.data.label;
    }

    if (this.data?.existingValue) {
      this.existingValue = this.data.existingValue;
    }

    this.createForm();
  }

  ngOnDestroy() {
    super.ngOnDestroy();
  }

  private createForm() {
    this.form = this.formBuilder.group({
      value: [this.existingValue ? this.existingValue : null, Validators.required],
    });
  }

  controlHasError(controlName: string, validationType: string): boolean {
    return FormHelper.controlHasError(this.form, controlName, validationType);
  }

  submit() {
    if (!this.form.dirty) return;

    const controls = this.form.controls;

    if (this.form.invalid) {
      Object.keys(controls).forEach((controlName) => controls[controlName].markAsTouched());
      return;
    }

    this.dialogRef.close(controls.value?.value);
  }
}
